import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import SEO from './SEO';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

const CustomPage = ({ language }) => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPage = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API}/blog/page/${slug}`);
        setPage(response.data);
        setError('');
      } catch (err) {
        console.error('Error fetching page:', err);
        setError('Page not found');
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-800"></div>
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4 text-center">
        <h1 className="text-4xl font-bold text-orange-600 mb-4">Coming Soon</h1>
        <div className="text-6xl mb-6">🚧</div>
        <p className="text-xl text-gray-600 mb-8">This page is currently being updated or under construction.<br/>Please check back later.</p>
        <Link to="/" className="px-6 py-3 bg-green-700 text-white font-bold rounded-lg hover:bg-green-800 transition-colors">← Back to Home</Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <SEO 
        title={page.title} 
        description={`Read ${page.title} on Ahobilam.com`} 
        type="article"
      />
      
      <article className="max-w-4xl mx-auto bg-white rounded-lg shadow-md overflow-hidden p-8">
        <header className="mb-8 border-b pb-4 border-gray-200">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {page.title}
          </h1>
          <div className="flex items-center text-sm text-gray-500">
            {page.author && (
              <span className="mr-4 flex items-center">
                <span className="mr-1">👤</span> {page.author}
              </span>
            )}
            <span className="flex items-center">
              <span className="mr-1">📅</span> 
              {new Date(page.published_at || page.created_at).toLocaleDateString(
                language === 'ta' ? 'ta-IN' : 'en-US',
                { year: 'numeric', month: 'long', day: 'numeric' }
              )}
            </span>
          </div>
        </header>

        <div 
          className="prose prose-lg max-w-none text-gray-800"
          dangerouslySetInnerHTML={{ __html: page.content ? page.content.replace(/\[\/?(?:su_[a-zA-Z0-9_]+|caption|gallery|audio|video|embed|vc_[a-zA-Z0-9_]+)[^\]]*\]/gi, '') : '' }}
        />
      </article>
    </div>
  );
};

export default CustomPage;
